"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useAppDataSchemaInstance(selector) {
  const {
    item: appDataSchemaInstance,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.AppDataSchemaInstance,
    selector,
    (integrationApp) => selector ? integrationApp.appDataSchemaInstance(selector) : void 0
  );
  async function setup() {
    await accessor?.setup();
    await refresh();
  }
  return {
    appDataSchemaInstance,
    accessor,
    refresh,
    setup,
    ...rest
  };
}

export { useAppDataSchemaInstance };
